export const Gender ={
    Unknown: 0,
    Male: 1,
    Female: 2,
    NotBinary: 3,
};

export const UserTypes = {
    Single: 0,
    Team: 1,
};
